module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/33656936f6eb527d56d75904e3c22504.png";